// useComplexOrderDetails.ts
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { ComplexOrderInterface } from "../../../common/types/types";
import { ComplexOrderStatus } from "../../../common/types/enums";
import { selectCategoryList } from "../../../store/slices/categoryListSlice";
import {
  getComplexOrderStatusColor,
  getComplexOrderStatusTextColor,
} from "../../../common/utils/functions/enumToText";

export const useComplexOrderDetails = (order?: ComplexOrderInterface) => {
  const categoryList = useSelector(selectCategoryList);

  const getOrderStatusInfo = useCallback((status: ComplexOrderStatus) => {
    const statusMap: Record<number, { text: string }> = {
      [ComplexOrderStatus.DRAFT]: { text: "Новая" },
      [ComplexOrderStatus.SENT_TO_MANAGER]: { text: "Отправлена менеджеру" },
      [ComplexOrderStatus.IN_PROGRESS]: { text: "В работе" },
      [ComplexOrderStatus.APPROVED]: { text: "Согласована" },
      [ComplexOrderStatus.CONVERTED]: { text: "Конвертирована в заказ" },
      [ComplexOrderStatus.ARCHIVED]: { text: "Архивирована" },
    };

    const info = statusMap[status] || { text: "Неизвестно" };

    return {
      text: info.text,
      backgroundColor: getComplexOrderStatusColor(status),
      textColor: getComplexOrderStatusTextColor(status),
    };
  }, []);

  const getFieldName = useCallback(
    (fieldTemplateId?: number): string => {
      if (!fieldTemplateId) return "Поле";
      for (const category of categoryList) {
        const field = category.fields?.find((f: any) => f.id === fieldTemplateId);
        if (field) return field.name;
      }
      return "Поле";
    },
    [categoryList],
  );

  return {
    getOrderStatusInfo,
    getFieldName,
  };
};